// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Auth.css */

/* Keep the container or adjust as needed */
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - var(--navbar-height));
  padding: 5rem 1rem 2rem; /* Added more top padding */
  background: var(--gradient-hero); /* Use the hero gradient */
}

/* UPDATED Auth card */
.auth-card {
  background: var(--bg-primary); /* White background */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: var(--border-radius-3xl); /* rounded-3xl */
  padding: 2rem; /* p-8 */
  width: 100%;
  max-width: 500px; /* Adjust as needed */
  box-shadow: var(--shadow-2xl);
  position: relative;
  overflow: hidden;
}
/* Remove ::before glow effect */
.auth-card::before {
  display: none;
}

.auth-card h2 {
  text-align: center;
  margin-bottom: 1rem; /* mb-4 */
  font-size: 1.875rem; /* text-3xl */
  color: var(--text-primary); /* Dark text */
  font-weight: 700; /* font-bold */
}

.auth-description {
  color: var(--text-secondary); /* Medium gray text */
  margin-bottom: 2rem; /* mb-8 */
  line-height: 1.75; /* leading-relaxed */
  text-align: center;
  font-size: 1.125rem; /* text-lg */
}

.form-group {
  margin-bottom: 1.5rem; /* mb-6 */
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem; /* mb-2 */
  color: var(--text-primary);
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
}

/* UPDATED Input field styling */
.form-group input {
  width: 100%;
  padding: 0.75rem 1rem; /* px-4 py-3 */
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg); /* rounded-lg */
  background: var(--bg-secondary); /* Light gray background */
  color: var(--text-primary);
  font-size: 1rem; /* text-base */
  transition: all 0.3s ease;
  font-family: inherit;
}
.form-group input:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border on focus */
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2); /* Red ring */
  background: var(--bg-primary); /* White background on focus */
}
.form-group input::placeholder {
  color: #9CA3AF; /* gray-400 */
}

/* Error state styling */
.form-group input.error {
  border-color: var(--error-color);
  background: var(--error-bg-light); /* Light red background */
  /* Keep animation if desired */
}
.field-error {
  display: block;
  color: var(--error-color);
  font-size: 0.875rem; /* text-sm */
  margin-top: 0.5rem; /* mt-2 */
  font-weight: 500;
}

/* UPDATED Button styling */
.auth-button {
  /* CHANGE THIS LINE: */
  /* background: var(--gradient-button); */
  background-image: var(--gradient-button); /* Use background-image for gradient */
  background-color: var(--primary-red-medium); /* Add fallback background color */

  /* Keep the rest of the styles */
  color: var(--text-on-gradient);
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;
  font-weight: 600;
  text-align: center;
}

/* Remove button ::before effect */
.auth-button::before {
  display: none;
}

.auth-button:hover:not(:disabled) {
  box-shadow: var(--shadow-lg);
  transform: scale(1.03); /* Slightly different hover effect */
  /* Consider slightly changing gradient on hover if desired */
}
.auth-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Error and success message styling */
.auth-error {
  background: var(--error-bg-light);
  color: var(--error-color);
  padding: 1rem;
  border-radius: var(--border-radius-lg);
  margin: 1.5rem 0;
  text-align: center;
  border: 1px solid var(--border-accent);
  font-size: 0.875rem; /* text-sm */
}
.auth-success {
  background: var(--success-bg-light);
  color: var(--success-color);
  padding: 1rem;
  border-radius: var(--border-radius-lg);
  margin: 1.5rem 0;
  text-align: center;
  border: 1px solid #A7F3D0; /* light green border */
  font-size: 0.875rem;
}

/* Footer links in auth */
.auth-footer {
  text-align: center;
  margin-top: 1.5rem; /* mt-6 */
  color: var(--text-secondary);
  font-size: 0.875rem; /* text-sm */
}
.auth-footer a {
  color: var(--text-accent);
  text-decoration: none;
  font-weight: 500;
}
.auth-footer a:hover {
  text-decoration: underline;
}

/* Forgot password link */
.forgot-password {
  text-align: right;
  margin-top: -0.5rem; /* pull up slightly */
  margin-bottom: 1rem; /* mb-4 */
}
.forgot-password a {
  color: var(--text-accent);
  font-size: 0.875rem; /* text-sm */
  text-decoration: none;
}
.forgot-password a:hover {
  text-decoration: underline;
}

/* Remove unused styles if any (like social login if not implemented) */
.social-login-section, .password-strength {
  display: none;
}

/* Update mobile styles if needed, but Tailwind is mobile-first */
@media (max-width: 480px) {
  .auth-card {
    padding: 1.5rem; /* Adjust padding for small screens */
  }
  .auth-card h2 {
    font-size: 1.5rem; /* text-2xl */
  }
  .auth-description {
    font-size: 1rem; /* text-base */
  }
}
.login-help {
  margin-top: 2rem;
  padding: 1rem;
  background: var(--bg-secondary); /* Use very light gray background */
  border: 1px solid var(--border-primary); /* Use light gray border */
  border-radius: var(--border-radius-lg); /* Consistent border radius */
  font-size: 0.85rem;
  color: var(--text-secondary); /* Use medium gray text color for contrast */
  text-align: center;
  line-height: 1.5; /* Add line height for readability */
}

.login-help p {
  margin-bottom: 0.5rem; /* Add spacing between paragraphs */
}

.login-help p:last-child {
  margin-bottom: 0;
}

.login-help strong {
  color: var(--text-primary); /* Use darker text for strong elements */
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/Auth.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,2CAA2C;AAC3C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB,EAAE,2BAA2B;EACpD,gCAAgC,EAAE,0BAA0B;AAC9D;;AAEA,sBAAsB;AACtB;EACE,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC,EAAE,sBAAsB;EAC/D,uCAAuC,EAAE,gBAAgB;EACzD,aAAa,EAAE,QAAQ;EACvB,WAAW;EACX,gBAAgB,EAAE,qBAAqB;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB,EAAE,aAAa;EAClC,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB,EAAE,oBAAoB;EACvC,kBAAkB;EAClB,mBAAmB,EAAE,YAAY;AACnC;;AAEA;EACE,qBAAqB,EAAE,SAAS;AAClC;;AAEA;EACE,cAAc;EACd,qBAAqB,EAAE,SAAS;EAChC,0BAA0B;EAC1B,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,qBAAqB,EAAE,cAAc;EACrC,uCAAuC;EACvC,sCAAsC,EAAE,eAAe;EACvD,+BAA+B,EAAE,0BAA0B;EAC3D,0BAA0B;EAC1B,eAAe,EAAE,cAAc;EAC/B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gCAAgC,EAAE,wBAAwB;EAC1D,4CAA4C,EAAE,aAAa;EAC3D,6BAA6B,EAAE,8BAA8B;AAC/D;AACA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,iCAAiC,EAAE,yBAAyB;EAC5D,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB,EAAE,YAAY;EACjC,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC,EAAE,sCAAsC;EAChF,2CAA2C,EAAE,kCAAkC;;EAE/E,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB,EAAE,oCAAoC;EAC5D,4DAA4D;AAC9D;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,iCAAiC;EACjC,yBAAyB;EACzB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB,EAAE,YAAY;AACnC;AACA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB,EAAE,uBAAuB;EAClD,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,4BAA4B;EAC5B,mBAAmB,EAAE,YAAY;AACnC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB,EAAE,qBAAqB;EAC1C,mBAAmB,EAAE,SAAS;AAChC;AACA;EACE,yBAAyB;EACzB,mBAAmB,EAAE,YAAY;EACjC,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe,EAAE,qCAAqC;EACxD;EACA;IACE,iBAAiB,EAAE,aAAa;EAClC;EACA;IACE,eAAe,EAAE,cAAc;EACjC;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B,EAAE,mCAAmC;EACpE,uCAAuC,EAAE,0BAA0B;EACnE,sCAAsC,EAAE,6BAA6B;EACrE,kBAAkB;EAClB,4BAA4B,EAAE,4CAA4C;EAC1E,kBAAkB;EAClB,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,qBAAqB,EAAE,mCAAmC;AAC5D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B,EAAE,wCAAwC;EACpE,gBAAgB;AAClB","sourcesContent":["/* src/styles/Auth.css */\n\n/* Keep the container or adjust as needed */\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - var(--navbar-height));\n  padding: 5rem 1rem 2rem; /* Added more top padding */\n  background: var(--gradient-hero); /* Use the hero gradient */\n}\n\n/* UPDATED Auth card */\n.auth-card {\n  background: var(--bg-primary); /* White background */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: var(--border-radius-3xl); /* rounded-3xl */\n  padding: 2rem; /* p-8 */\n  width: 100%;\n  max-width: 500px; /* Adjust as needed */\n  box-shadow: var(--shadow-2xl);\n  position: relative;\n  overflow: hidden;\n}\n/* Remove ::before glow effect */\n.auth-card::before {\n  display: none;\n}\n\n.auth-card h2 {\n  text-align: center;\n  margin-bottom: 1rem; /* mb-4 */\n  font-size: 1.875rem; /* text-3xl */\n  color: var(--text-primary); /* Dark text */\n  font-weight: 700; /* font-bold */\n}\n\n.auth-description {\n  color: var(--text-secondary); /* Medium gray text */\n  margin-bottom: 2rem; /* mb-8 */\n  line-height: 1.75; /* leading-relaxed */\n  text-align: center;\n  font-size: 1.125rem; /* text-lg */\n}\n\n.form-group {\n  margin-bottom: 1.5rem; /* mb-6 */\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem; /* mb-2 */\n  color: var(--text-primary);\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n}\n\n/* UPDATED Input field styling */\n.form-group input {\n  width: 100%;\n  padding: 0.75rem 1rem; /* px-4 py-3 */\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-lg); /* rounded-lg */\n  background: var(--bg-secondary); /* Light gray background */\n  color: var(--text-primary);\n  font-size: 1rem; /* text-base */\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n.form-group input:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border on focus */\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2); /* Red ring */\n  background: var(--bg-primary); /* White background on focus */\n}\n.form-group input::placeholder {\n  color: #9CA3AF; /* gray-400 */\n}\n\n/* Error state styling */\n.form-group input.error {\n  border-color: var(--error-color);\n  background: var(--error-bg-light); /* Light red background */\n  /* Keep animation if desired */\n}\n.field-error {\n  display: block;\n  color: var(--error-color);\n  font-size: 0.875rem; /* text-sm */\n  margin-top: 0.5rem; /* mt-2 */\n  font-weight: 500;\n}\n\n/* UPDATED Button styling */\n.auth-button {\n  /* CHANGE THIS LINE: */\n  /* background: var(--gradient-button); */\n  background-image: var(--gradient-button); /* Use background-image for gradient */\n  background-color: var(--primary-red-medium); /* Add fallback background color */\n\n  /* Keep the rest of the styles */\n  color: var(--text-on-gradient);\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: var(--border-radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  margin-top: 1rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Remove button ::before effect */\n.auth-button::before {\n  display: none;\n}\n\n.auth-button:hover:not(:disabled) {\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.03); /* Slightly different hover effect */\n  /* Consider slightly changing gradient on hover if desired */\n}\n.auth-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Error and success message styling */\n.auth-error {\n  background: var(--error-bg-light);\n  color: var(--error-color);\n  padding: 1rem;\n  border-radius: var(--border-radius-lg);\n  margin: 1.5rem 0;\n  text-align: center;\n  border: 1px solid var(--border-accent);\n  font-size: 0.875rem; /* text-sm */\n}\n.auth-success {\n  background: var(--success-bg-light);\n  color: var(--success-color);\n  padding: 1rem;\n  border-radius: var(--border-radius-lg);\n  margin: 1.5rem 0;\n  text-align: center;\n  border: 1px solid #A7F3D0; /* light green border */\n  font-size: 0.875rem;\n}\n\n/* Footer links in auth */\n.auth-footer {\n  text-align: center;\n  margin-top: 1.5rem; /* mt-6 */\n  color: var(--text-secondary);\n  font-size: 0.875rem; /* text-sm */\n}\n.auth-footer a {\n  color: var(--text-accent);\n  text-decoration: none;\n  font-weight: 500;\n}\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Forgot password link */\n.forgot-password {\n  text-align: right;\n  margin-top: -0.5rem; /* pull up slightly */\n  margin-bottom: 1rem; /* mb-4 */\n}\n.forgot-password a {\n  color: var(--text-accent);\n  font-size: 0.875rem; /* text-sm */\n  text-decoration: none;\n}\n.forgot-password a:hover {\n  text-decoration: underline;\n}\n\n/* Remove unused styles if any (like social login if not implemented) */\n.social-login-section, .password-strength {\n  display: none;\n}\n\n/* Update mobile styles if needed, but Tailwind is mobile-first */\n@media (max-width: 480px) {\n  .auth-card {\n    padding: 1.5rem; /* Adjust padding for small screens */\n  }\n  .auth-card h2 {\n    font-size: 1.5rem; /* text-2xl */\n  }\n  .auth-description {\n    font-size: 1rem; /* text-base */\n  }\n}\n.login-help {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: var(--bg-secondary); /* Use very light gray background */\n  border: 1px solid var(--border-primary); /* Use light gray border */\n  border-radius: var(--border-radius-lg); /* Consistent border radius */\n  font-size: 0.85rem;\n  color: var(--text-secondary); /* Use medium gray text color for contrast */\n  text-align: center;\n  line-height: 1.5; /* Add line height for readability */\n}\n\n.login-help p {\n  margin-bottom: 0.5rem; /* Add spacing between paragraphs */\n}\n\n.login-help p:last-child {\n  margin-bottom: 0;\n}\n\n.login-help strong {\n  color: var(--text-primary); /* Use darker text for strong elements */\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
